import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from './actionTypes';

const serializedState = JSON.parse(localStorage.getItem('authUser'));

const initialState = {
  error: '',
  loading: false,
  user: serializedState !== null ? serializedState : {},
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
        user: action.payload.user,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        user: action.payload,
      };
      break;
    case LOGOUT_USER:
      state = { ...state, user: action.payload };

      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state, user: action.payload };
      break;
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
